export const normalizeDashboardSearchText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("de")
    .trim();

export const matchesDashboardVehicleSearch = (vehicle, rawQuery) => {
  const query = normalizeDashboardSearchText(rawQuery);
  if (!query) return true;

  const vehicleData = vehicle?.vehicleData || vehicle || {};
  const searchableText = normalizeDashboardSearchText(
    [
      vehicleData?.marke,
      vehicleData?.model,
      vehicleData?.fahrzeug_eigentum?.address?.state,
    ]
      .filter(Boolean)
      .join(" ")
  );

  return query
    .split(/\s+/)
    .filter(Boolean)
    .every((term) => searchableText.includes(term));
};
